<template>
  <DetailTomanTransaction />
</template>

<script>
import DetailTomanTransaction from '../../../components/crypto/DetailTomanTransaction.vue'
export default {
  components: {
    DetailTomanTransaction,
  },
}
</script>

<style scoped lang="scss"></style>
